export default "__VITE_ASSET__Dcm4_ClG__"